import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=dd615074&scoped=true&"
import script from "./CategoryCard.vue?vue&type=script&lang=ts&"
export * from "./CategoryCard.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryCard.vue?vue&type=style&index=0&id=dd615074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd615074",
  null
  
)

export default component.exports